import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e58f51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__simple-textfield" }
const _hoisted_2 = { class: "label-container" }
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = ["name", "value", "type", "placeholder", "maxlength"]

import { computed, ref, toRefs, watch } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'simple-textfield',
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
    password: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      // v-model
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    verySmall: {
      type: Boolean,
      default: false
    },
    forceType: {
      type: String,
      default: null,
    },
    maxLength: {
      type: Number,
      default: null,
    }
  },
  emits: ["input"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const value = ref<any>(props.modelValue);

  const emit = __emit;

  const type = computed(() => {
    if (props.forceType) {
      return props.forceType;
    } else if (props.password) {
      return "password";
    } else {
      return "text";
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: _normalizeClass({ small: __props.small, 'very-small': __props.verySmall })
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        name: __props.name,
        value: value.value,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event.target.value))),
        type: type.value,
        placeholder: __props.placeholder,
        class: _normalizeClass({ small: __props.small, 'very-small': __props.verySmall }),
        maxlength: __props.maxLength
      }, null, 42, _hoisted_4),
      (!!__props.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["frontend-icon", __props.icon])
          }, null, 2))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})